// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"Logo_logoContainer__e_vYb","logoImage":"Logo_logoImage__daWgp"};